// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GmFV","fullView":"styles_fullView__7tyxQ"};